import { useMutation } from 'react-query'
import { HeadingPages } from '../../../components/HeadingPages'
import { api } from '../../../services/api'
import { useForm } from 'react-hook-form'
import { format } from 'date-fns'
import { Button, Flex, Input, Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import { Loader } from '../../../components/ComponentLoader/Loader'
import Axios from 'axios'
import { useState } from 'react'
import { formatPrice } from '../../../utils/formatPrice'
import { ControleItem } from './ControleItem'

export function ControleImposto() {
  const { handleSubmit, register } = useForm()
  const [loading, setLoading] = useState(false)

  const { data, mutateAsync, isLoading } = useMutation(async (data) => {
    const response = await api.get(`/site/v2/controle-crm/verifica-imposto-compra/${data.inicial}/${data.final}`)

    const dataFormatted = response.data.sort((a, b) => {
      return new Date(a.data_emissao) - new Date(b.data_emissao)
    })

    return dataFormatted
  })

  async function getDataControlImposto(data) {
    await mutateAsync(data)
  }

  async function generateExcel() {
    if (!data) return
    if (data.length === 0) return

    setLoading(true)

    const header = [
      'NUNOTA',
      'NFE',
      'AD_NUMINNO',
      'DATA_EMISSAO',
      'DATA_SAIDA',
      'CNPJ_REMETENTE',
      'RAZAOSOCIAL',
      'CNPJ_CLIENTE',
      'RAZAO_SOCIAL_CLIENTE',
      'ESTADO_ORIGEM',
      'ESTADO_CLIENTE',
      'CLIENTE_ENTREGA_ESTADO_DESTINO',
      'CLIENTE_ENTREGA_CNPJ',
      'CLIENTE_ENTREGA_INSCRICAOEST',
      'CODPROD',
      'CFOP',
      'NCM',
      'CEST',
      'VLRUNIT',
      'QTDNEG',
      'VLRTOT',
      'BASEICMS',
      'VLRICMS',
      'BASESUBSTIT',
      'VLRSUBST',
      'BASEIPI',
      'VLRIPI',
      'VLRFRETE',
      'NOTAXML',
      'CHAVE_ACESSO',
    ]

    function formatValue(value) {
      if (value) {
        const numericValue = parseFloat(value.replace('.', ','))
        return numericValue
      }
      return value
    }

    const dataItems = data?.map((item) => {
      return {
        numero_nota: item.numero_unico || 'Não informado',
        nfe: item.numero_nfe || 'Não informado',
        ad_numinno: item.numero_pedido || 'Não informado',
        data_emissao: item.data_emissao ? format(new Date(item.data_emissao), 'dd/MM/yyyy') : 'Não informado',
        data_saida: item.data_saida ? format(new Date(item.data_saida), 'dd/MM/yyyy') : 'Não informado',
        cnpj_remetente: item.cnpj_remetente || 'Não informado',
        razao_social: item.razao_social || 'Não informado',
        cnpj_cliente: item.cnpj_cliente || 'Não informado',
        razao_social_cliente: item.razao_social_cliente || 'Não informado',
        estado_origem: item.estado_origem || 'Não informado',
        estado_cliente: item.estado_cliente || 'Não informado',
        cliente_entrega_estado_destino: item.cliente_entrega_estado_destino || 'Não informado',
        cliente_entrega_cnpj: item.cliente_entrega_cnpj || 'Não informado',
        cliente_entrega_inscricaoest: item.cliente_entrega_inscricao || 'Não informado',
        codprod: item.codigo_produto || 'Não informado',
        cfop: item.cfpo || 'Não informado',
        ncm: item.ncm || 'Não informado',
        cest: item.cest || 'Não informado',
        vlrunit: formatValue(item.valor_unitario),
        qtdneg: item.quantidade_negociada,
        vlrtot: formatValue(item.valor_total),
        baseicms: formatValue(item.base_icms),
        vlricms: formatValue(item.valor_icms),
        basesubstit: formatValue(item.base_subs_tit),
        vlrsubst: formatValue(item.vlr_subs_tit),
        baseipi: formatValue(item.base_ipi),
        vlripi: formatValue(item.vlr_ipi),
        vlrfrete: formatValue(item.vlr_frete),
        notaxml: 'Não informado',
        chave_acesso: item.chave_acesso || 'Não informado',
      }
    })

    try {
      const response = await Axios.post(
        'https://apihomolog.innovationbrindes.com.br/node/transform-to-excel',
        {
          header: header,
          data: dataItems,
        },
        { responseType: 'arraybuffer' }
      )

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${new Date()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }

    setLoading(false)
  }

  return (
    <>
      <HeadingPages name="Controle de Imposto" />

      {isLoading && <Loader />}

      <Flex as="form" onSubmit={handleSubmit(getDataControlImposto)} w="100%" maxW={1480} mx="auto" px="6" align="center" flexDir="column">
        <Flex alignItems="center" justifyContent="center" w="full" mt="1rem" gap="1rem">
          <Input type="date" {...register('inicial')} />
          <Input type="date" {...register('final')} />

          <Button colorScheme="blue" maxW="120px" w="full" type="submit">
            Buscar
          </Button>
          {data && (
            <Button
              onClick={generateExcel}
              backgroundColor="green.500"
              color="white"
              _hover={{
                filter: 'brightness(0.9)',
              }}
              isLoading={loading}
              maxW="120px"
              w="full"
              loadingText="Gerando excel"
            >
              Gerar Excel
            </Button>
          )}
        </Flex>

        {!isLoading && (
          <TableContainer
            maxW="1480px"
            w="full"
            mt="1rem"
            size="sm"
            maxH="500px"
            overflowY="scroll"
            boxShadow="md"
            borderRadius="md"
            border="1px solid #e2e8f0"
          >
            <Table variant="simple">
              <Thead position="sticky" top="0" bg="#E2E8F0">
                <Tr>
                  <Th>Numero Único</Th>
                  <Th>Numero Nfe</Th>
                  <Th>Numero Pedido</Th>
                  <Th>Data Emissão</Th>
                  <Th>Limite Produção</Th>
                  <Th>Cnpj Remetente</Th>
                  <Th>Razão Social</Th>
                  <Th>Cnpj Cliente</Th>
                  <Th>Razao social Cliente</Th>
                  <Th>Estado Origem</Th>
                  <Th>Estado Cliente</Th>
                  <Th>Cliente entrega estado Destino</Th>
                  <Th>Cliente entrega CNPJ</Th>
                  <Th>Cliente entrega Escricao est</Th>
                  <Th>Cod Prod</Th>
                  <Th>CFOP</Th>
                  <Th>NCM</Th>
                  <Th>Cest</Th>
                  <Th>Valor Unitário</Th>
                  <Th>Quantidade</Th>
                  <Th>Valor Total</Th>
                  <Th>Base ICMS</Th>
                  <Th>Valor ICMS</Th>
                  <Th>Base Subs tit</Th>
                  <Th>Valor Subs. Tit</Th>
                  <Th>Base IPI</Th>
                  <Th>Valor IPI</Th>
                  <Th>Valor Frete</Th>
                  <Th>Nota XML</Th>
                  <Th>Chave</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.map((item) => (
                  <ControleItem key={item.numero_nf} item={item} />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Flex>
    </>
  )
}
